<button
  mat-flat-button
  type="button"
  data-testid="campaign-export-button"
  class="mat-slim-button !pl-3 !pr-4 !min-w-fit"
  (click)="onExportClick()"
>
  <div class="flex items-center gap-2">
    <app-icon src="/icons/share.svg" alt="Export" [size]="24" />
    <span>{{ 'pages.campaignDetails.export.share' | translate }}</span>
  </div>
</button>
